<ng-template #dropdownButtonTemplate>
  <ng-container *ngIf="isActive; else defaultButtonText">
    {{ 'common.currency.short' | i18n }} {{ appliedFilter.min.text }} -
    {{ appliedFilter.max.text }}
  </ng-container>
  <ng-template #defaultButtonText>
    {{ 'filters.price.label' | i18n }}
  </ng-template>
</ng-template>

<ng-template #dropdownContentTemplate>
  <lib-price-filter (update)="select($event)"></lib-price-filter>
</ng-template>

<ng-template #applyButtonTemplate let-close="close">
  <button class="filter-apply-button" (click)="applyChanges(); close()">
    {{ 'common.apply' | i18n }}
  </button>
</ng-template>

<app-filter-dropdown
  [preferredWidth]="271"
  [dropdownButtonTemplate]="dropdownButtonTemplate"
  [dropdownContentTemplate]="dropdownContentTemplate"
  [applyButtonTemplate]="applyButtonTemplate"
  [hasValue]="isActive"
  (clear)="reset()"
>
</app-filter-dropdown>
